import styled from 'styled-components';

import {
  layers,
} from '../../theme';

import {
  HeadingOne,
} from '../../elements';

export const Position = styled.div`
  height: 0;
  opacity: 1;
  position: absolute;
  transform-style: preserve-3d;
  transition: all .2s ease-in-out;
  width: 0;

  &.front {
    transform: scale(0.7);
    z-index: ${layers.INTRO__CLOUD_ITEMS__FRONT};
  }

  &.middle {
    opacity: 0.7;
    transform: scale(0.5);
    z-index: ${layers.INTRO__CLOUD_ITEMS__MIDDLE};
  }

  &.back {
    opacity: 0.5;
    transform: scale(0.3);
    z-index: ${layers.INTRO__CLOUD_ITEMS__BACK};
  }

  &.twinkling {
    animation: twinkle 5s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
  }

  &.inactive {
    opacity: 0.3;
    transform: scale(0.3);
    z-index: ${layers.INTRO__CLOUD_ITEMS__INACTIVE};
  }

  &.hovered {
    opacity: 1;
    transform: scale(0.7);
    z-index: ${layers.INTRO__CLOUD_ITEMS__ZOOMED};
  }

  &.zoomed {
    opacity: 1;
    transform: scale(1.5);
    z-index: ${layers.INTRO__CLOUD_ITEMS__ZOOMED};
  }
`;

export const Wrapper = styled.div`
  cursor: zoom-in;
  height: 0;
  transition: all .2s ease-in-out;
  transform: translate3D(-50%, -50%, 0);
  width: 0;
`;

export const Image = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  left: 50%;
  position: absolute;
  top: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/IntroCloudItem/style.js